import { JsonObject, JsonProperty } from 'json2typescript';

import { DisinvestmentInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Disinvestment')
export class Disinvestment implements DisinvestmentInterface {
    @JsonProperty('IsTotal', Boolean, true)
    private _isTotal: boolean = undefined;

    @JsonProperty('Amount', Number, true)
    private _amount: number = undefined;

    @JsonProperty('CashRefund', Boolean, true)
    private _cashRefund: boolean = undefined;

    @JsonProperty('IBAN', StringAdapter, true)
    private _iban: string = undefined;

    @JsonProperty('CashAccountIBAN', StringAdapter, true)
    private _cashAccountIBAN: string = undefined;

    private _disclaimer: boolean = undefined;

    constructor() {
        this._isTotal = true;
        this._amount = 0;
        this._cashRefund = true;
        this._disclaimer = false;
    }

    get isTotal(): boolean {
        return this._isTotal;
    }

    set isTotal(value: boolean) {
        this._isTotal = value;

        if (value) {
            this._amount = 0;
        }
    }

    get amount(): number {
        return this._amount;
    }

    set amount(value: number) {
        this._amount = value;
    }

    get cashRefund(): boolean {
        return this._cashRefund;
    }

    set cashRefund(value: boolean) {
        this._cashRefund = value;
    }

    get iban(): string {
        return this._iban;
    }

    set iban(value: string) {
        this._iban = value.replace(/\s+/, '');
    }

    get cashAccountIBAN(): string {
        return this._cashAccountIBAN;
    }

    set cashAccountIBAN(value: string) {
        this._cashAccountIBAN = value.replace(/\s+/, '');
    }

    get disclaimer(): boolean {
        return this._disclaimer;
    }

    set disclaimer(value: boolean) {
        this._disclaimer = value;
    }

    isComplete(): boolean {
        return (this.isTotal || (!this.isTotal && this.amount > 0)) && this.disclaimer;
    }
}
